module.exports = __webpack_public_path__ + "img/part2-right-bg.14edc3b2.png";